import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { IconButton } from "./icon-button";

export interface ModalProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  title?: string;
  width?: number;
}

export function Modal({ open, onClose, children, title, width = 460 }: ModalProps) {
  const { t } = useTranslation();
  if (!open) return null;
  return (
    <div className="modal-scrim" onClick={onClose}>
      <div className="modal" style={{ maxWidth: width }} onClick={(e) => e.stopPropagation()}>
        {title && (
          <div className="modal-head">
            <h3>{title}</h3>
            <IconButton name="x" onClick={onClose} label={t("actions.close")} size={18} />
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
